import { assertNever } from 'owa-assert';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { getDownloadToken } from 'owa-files-url';
import * as OwaFilesUrl from 'owa-files-url';
import { getOwaCanaryCookie } from 'owa-service/lib/canary';
// Get the Url for cloudy attachments.
function getAttachmentUrlForCloudy(attachment, attachmentUrlType, isReadOnly, includeCanary) {
    if (includeCanary === void 0) { includeCanary = true; }
    var _a = attachment, attachmentId = _a.AttachmentId, name = _a.Name, originalPermissionType = _a.OriginalPermissionType, permissionType = _a.PermissionType, attachLongPathName = _a.AttachLongPathName;
    switch (attachmentUrlType) {
        case 0 /* FullFile */:
        case 3 /* Print */:
            return OwaFilesUrl.getAttachmentUrlForCloudy(attachmentId, attachLongPathName, attachmentUrlType, isReadOnly, permissionType, originalPermissionType, includeCanary, name);
        case 1 /* Preview */:
            if (attachment.AttachmentPreviewUrl) {
                return attachment.AttachmentPreviewUrl;
            }
            else {
                return OwaFilesUrl.getAttachmentUrlForCloudy(attachmentId, attachLongPathName, 1 /* Preview */, isReadOnly, permissionType, originalPermissionType, includeCanary, name);
            }
        case 2 /* Thumbnail */:
            return attachment.AttachmentThumbnailUrl;
        default:
            return assertNever(attachmentUrlType);
    }
}
// TODO VSO#17696: Rename it to getAttachmentUrl
// Get the download Url for classic attachments.
export function getAttachmentUrlForClassic(attachmentId, attachmentUrlType, addIsDownloadQueryParam, isConsumer, includeDownloadToken) {
    if (addIsDownloadQueryParam === void 0) { addIsDownloadQueryParam = false; }
    if (isConsumer === void 0) { isConsumer = isControlFeatureEnabled('doc-consumerUrl'); }
    if (includeDownloadToken === void 0) { includeDownloadToken = true; }
    return OwaFilesUrl.getAttachmentUrlForClassic(attachmentId.mailboxInfo && attachmentId.mailboxInfo.mailboxId, attachmentId, attachmentUrlType, addIsDownloadQueryParam, isConsumer, includeDownloadToken);
}
/*
 * Initialize the preview URL
 * @returns {FetchPreviewUrl} The request to fetch the preview url
 */
export function getPreviewUrlRequest(attachmentId, attachment, isCloudy, isReadyOnly, addIsDownloadQueryParam, isConsumer) {
    if (addIsDownloadQueryParam === void 0) { addIsDownloadQueryParam = false; }
    if (isConsumer === void 0) { isConsumer = isControlFeatureEnabled('doc-consumerUrl'); }
    var previewUrl = isCloudy
        ? getAttachmentUrlForCloudy(attachment, 1 /* Preview */, isReadyOnly, false /* includeCanary */)
        : getAttachmentUrlForClassic(attachmentId, 1 /* Preview */, addIsDownloadQueryParam, isConsumer, false /* includeDownloadToken */);
    if (isCloudy) {
        return {
            url: previewUrl,
            init: {
                credentials: 'include',
            },
        };
    }
    else {
        // If the attachment is classic then we send the download token
        // as header
        var token = getDownloadToken();
        var headers = new Headers();
        headers.set('X-Token', token);
        headers.set('X-OWA-CANARY', getOwaCanaryCookie());
        return {
            url: previewUrl,
            init: {
                headers: headers,
            },
        };
    }
}
export default function getAttachmentUrl(attachmentId, attachment, attachmentUrlType, isCloudy, isReadyOnly, addIsDownloadQueryParam, isConsumer) {
    if (addIsDownloadQueryParam === void 0) { addIsDownloadQueryParam = false; }
    if (isConsumer === void 0) { isConsumer = isControlFeatureEnabled('doc-consumerUrl'); }
    var downloadUrl = isCloudy
        ? getAttachmentUrlForCloudy(attachment, attachmentUrlType, isReadyOnly)
        : getAttachmentUrlForClassic(attachmentId, attachmentUrlType, addIsDownloadQueryParam, isConsumer);
    return downloadUrl;
}
//# sourceMappingURL=getAttachmentUrl.js.map